import {
  BookingType,
  Frequence,
  NotSerializedBookingInputs
} from "../../../features/Booking-Form/typings/booking-inputs";
import { conferenceZoneActivityStrategy } from "./conferenceZoneActivityStrategy";
import { conferenceZoneStandardStrategy } from "./conferenceZoneStandardStrategy";
import { placeBookingStrategy } from "./placeBookingStrategy";
import { placeZoneStrategy } from "./placeZoneStrategy";
import { vehicleBookingStrategy } from "./vehicleBookingStrategy";
import { AffectedExistingBooking } from "../../../features/Booking-Form/typings/cancel-existing-booking.types";
import { visitorBookingStrategy } from "./visitorBookingStrategy";

export type BookingStrategyContext = {
  inputs: NotSerializedBookingInputs;
  sub: string;
  /** When true, user has FleetAdmin or TenantAdmin role (for vehicle: use on-behalf endpoint when booking for someone else). */
  isFleetOrTenantAdmin: boolean;
  /** User ID the booking is for. When undefined or equal to sub, treat as self-booking. Used by vehicle strategy to choose POST /booking/vehicle vs POST /fleet/bookings/on-behalf. */
  bookingForUserId?: string;
  timezoneMobileWorking: string;
  conferenceInputs: any;
  conferenceBooking: boolean;

  standardBookingInfo: {
    specificDays: string[] | undefined;
    frequence: Frequence | undefined;
    interval: number | undefined;
    bookingMonthDay: number | undefined;
    bookingYearDay: string | undefined;
  };
  standardBookingTimes: {
    startDate: string | null;
    endDate: string | null;
    startTime: string | null;
    endTime: string | null;
  };

  transformBookingUsers: Function;
  handlePromise: Function;
  handleToBookingServiceDto: Function;
  weekdayInput: Function;
  conferenceBookingUsers: Function;

  onSuccess: () => void;
  onError: (err: any) => void;
  onCancelExistingConfirmationRequired: (
    affected: AffectedExistingBooking[],
    retry: () => void
  ) => void;
};

export const bookingStrategyMap: Record<string, (ctx: BookingStrategyContext) => void> = {
  [BookingType.WORKPLACE]: placeBookingStrategy,
  [BookingType.PARKINGPLACE]: placeBookingStrategy,
  [BookingType.ELECTRICCHARGINGSTATIONPLACE]: placeBookingStrategy,

  [`${BookingType.CONFERENCEZONE}_STANDARD`]: conferenceZoneStandardStrategy,
  [`${BookingType.CONFERENCEZONE}_ACTIVITY`]: conferenceZoneActivityStrategy,

  [BookingType.PLACEZONE]: placeZoneStrategy,
  [BookingType.VEHICLE]: vehicleBookingStrategy,
  [BookingType.VISITOR]: visitorBookingStrategy
};
